// extracted by mini-css-extract-plugin
export default {"wrapper":"languageDropDown_wrapper__DmiW-","balloon":"languageDropDown_balloon__SSdhi","languageButton":"languageDropDown_languageButton__cq4MG"};